<ul class="tiles">
    <li class="tile" *ngFor="let user of users">
        <app-tile [user]="user"></app-tile>
    </li>
</ul>